import React from 'react';
import Reports from '../reports/index';
const Dashboard = () => {
    return (
        <Reports />
    )
};

export default Dashboard;